import withPost from '@lib/page';
import PostPage from '@views/pages/post';

export default withPost(PostPage);
